module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/1@2x_b9410a911328f2eba421d8b38c51a377.png";